var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tag-template',{staticClass:"heading",class:( _obj = {}, _obj[("heading--" + _vm.lineX)] = true, _obj ),attrs:{"tag":_vm.tag}},[_vm._v("\n\t"+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }